import { useCallback } from 'react'

import { CookieStorage } from '@/core/utils/cookies'

type Review = { rating: number; url: string }
type ReviewCookie = { [key: string]: number }

const REVIEW_COOKIE_NAME = 'CONTENT_REVIEW'

const useCookieReview = () => {
  const saveCookie = (payload: ReviewCookie) => {
    const expires = new Date()
    expires.setMonth(expires.getMonth() + 11)
    const stringifiedPayload = JSON.stringify(payload)
    CookieStorage.set(REVIEW_COOKIE_NAME, stringifiedPayload, expires.toUTCString())
  }

  const getCookie = () => {
    const reviewCookie = CookieStorage.get(REVIEW_COOKIE_NAME)
    if (!reviewCookie) return {} as ReviewCookie

    const parsedCookie: ReviewCookie = JSON.parse(reviewCookie)
    return parsedCookie
  }

  const saveReview = ({ rating, url }: Review) => {
    const reviewCookie = getCookie()

    const cookiePayload = { ...reviewCookie }
    cookiePayload[url] = rating
    return saveCookie(cookiePayload)
  }

  const getReviewByUrl = useCallback((url: string) => {
    const reviewCookie = getCookie()
    if (!reviewCookie) {
      return null
    }
    const review = reviewCookie[url]
    return review
  }, [])

  return {
    saveReview,
    getReviewByUrl,
  }
}

export default useCookieReview
